//** Component  */
import React from "react";

//** Lib */

import SupplierComparisonList from "./SupplierComparisonList";
import CustomTab from "../../components/common/RenderTab/CustomTab";
import { securityKey } from "../../navigation/SecurityKey";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";

function SupplierComparison() {
   const hasOpenTabPermission = hasFunctionalPermission(securityKey.SUPPLIERCOMPARISONOPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.SUPPLIERCOMPARISONARCHIVETAB);

  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: < SupplierComparisonList openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <SupplierComparisonList openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];

  return (
    <>
     <CustomTab data={data} />
    </>
  );
}

export default SupplierComparison;
